import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { "format-key": "0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_localize = _resolveComponent("localize")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createBlock(_component_tooltip, { class: "_flexinline _ai-c _jc-c" }, {
    content: _withCtx(() => [
      _renderSlot(_ctx.$slots, "content", {}, () => [
        _createVNode(_component_localize, {
          resource: _ctx.Resources.ProjectHome.ProjectApproximateCurrencyConversionTooltip
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]),
          _: 3 /* FORWARDED */
        }, 8 /* PROPS */, ["resource"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_base_icon, {
        name: "sync",
        class: _normalizeClass($options.computedIconClasses),
        "has-base-class": $props.hasBaseClass
      }, null, 8 /* PROPS */, ["class", "has-base-class"])
    ]),
    _: 3 /* FORWARDED */
  }))
}